import { applyMiddleware, combineReducers, compose, createStore } from 'redux';

import { roomReducer, RoomReducerState, roomMiddleware } from '../../modules/room/@store';
import { authReducer, AuthReducerState, authMiddleware } from '../../modules/auth/@store';
import { userReducer, UserReducerState, userMiddleware } from '../../modules/user/@store';
import { AppReducerState, appReducer } from './reducer';

import { appMiddleware } from './middleware';

declare var window: any;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export interface RootState {
    app: AppReducerState,
    auth: AuthReducerState;
    user: UserReducerState;
    room: RoomReducerState;
}

const reducers = combineReducers({
    'app': appReducer,
    'auth': authReducer,
    'room': roomReducer,
    'user': userReducer,
});

export const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(
            ...authMiddleware,
            ...roomMiddleware,
            ...appMiddleware,
            ...userMiddleware
        ),
    )
);